import React from 'react';
import PropTypes from 'prop-types';

import HeaderBox from '../header-box';
import Lightbox from '../lightbox';
import './side-by-side.css';

const SideBySide = ({
    bulletsList,
    buttonsList,
    copy,
    header,
    image,
    gif,
    imagePosition,
    sideHeader,
    icon,
    aspect,
}) => {
    return (
        <section
            className={
                imagePosition === 'left'
                    ? 'side-by-side'
                    : 'side-by-side dark-side'
            }
        >
            {header && <HeaderBox header={header} />}
            <div
                className={
                    imagePosition === 'left'
                        ? 'grid-container'
                        : 'grid-container image-right'
                }
            >
                <Lightbox
                    gif={gif}
                    image={image}
                    icon={icon}
                    aspect={aspect}
                ></Lightbox>

                <div className="text">
                    {sideHeader && <h2>{sideHeader}</h2>}
                    {copy ? Array.isArray(copy) ? copy : <p>{copy}</p> : null}
                    {bulletsList && (
                        <ul>
                            {bulletsList.map((bullet, index) => (
                                <li key={index}>{bullet}</li>
                            ))}
                        </ul>
                    )}
                    <div className="buttons">{buttonsList}</div>
                </div>
            </div>
        </section>
    );
};

SideBySide.defaultProps = {
    imagePosition: 'left',
};

SideBySide.propTypes = {
    bulletsList: PropTypes.arrayOf(PropTypes.string),
    buttonsList: PropTypes.arrayOf(PropTypes.element),
    gif: PropTypes.string,
    header: PropTypes.string,
    image: PropTypes.object,
    imagePosition: PropTypes.string,
    text: PropTypes.string,
};

export default SideBySide;
